import { SanityContentPage } from 'src/components/layouts/Page/SanityContentPage'

const HomePage = () => {
  return <SanityContentPage slug='home' />
}

export default HomePage
